import { BannerScroll } from './bannerScroll'
import { SectionA } from './section-a'
import { SectionB } from './section-b'
import { SectionC } from './section-c'
import { SectionD } from './section-d'
import { SectionE } from './section-e'
import { SectionF } from './section-f'
import { SectionG } from './section-g'
import { Wrap } from '../../components/wap'

import type { IndustryTag, PageContent, SolutionTag } from '../../pageContents'
import type { NewsListProps } from '../news'

export interface HomeDetailProps {
  productsContentsList: PageContent[]
  solutionTags: SolutionTag[]
  industryTags: IndustryTag[]
  industryContentsList: PageContent[]
  newsList: NewsListProps['data']
}

export const HomeDetail = (props: HomeDetailProps) => {
  const { productsContentsList, solutionTags, industryContentsList, industryTags, newsList } = props
  return (
    <Wrap>
      <div className='home-index'>
        <BannerScroll />

        <div className='section-box grey'>
          <SectionA data={productsContentsList} title='产品中心' />
        </div>

        <div className='section-box white'>
          <SectionB data={solutionTags} title='解决方案' />
        </div>

        <div className='section-box grey'>
          <SectionC
            industryContentsList={industryContentsList}
            industryTags={industryTags}
            title='应用案例'
          />
        </div>

        <div className='section-box white'>
          <SectionD data={newsList} title={'新闻资讯'} />
        </div>

        <div className='section-box grey'>
          <SectionE title='社会实践与责任' />
        </div>

        <div className='section-box white'>
          <SectionF title='合作伙伴' />
        </div>

        <div className='section-box grey'>
          <SectionG title='荣誉资质' />
        </div>
      </div>
    </Wrap>
  )
}
